import Layout from '@/views/layout'
const workRouter = [{
  path: '/work',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkPack',
    meta: {title: '入库', module: 'work', icon: 'pack'},
    component: () => import(/* webpackChunkName: "work" */ '@/views/work/Pack')
  }]
}, {
  path: '/work/send',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkSend',
    meta: {title: '送检', module: 'work', icon: 'check'},
    component: () => import('@/views/work/Send')
  }]
}, {
  path: '/work/recheck',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkRecheck',
    meta: {title: '复检', module: 'work', icon: 'recheck'},
    component: () => import('@/views/work/Recheck')
  }]
}, {
  path: '/work/scrap',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkScrap',
    meta: {title: '报废', module: 'work', icon: 'scrap'},
    component: () => import('@/views/work/Scrap')
  }]
}, {
  path: '/work/stats',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkStats',
    meta: {title: '统计', module: 'work', icon: 'stats'},
    component: () => import('@/views/work/Stats')
  }]
}]

export default workRouter
